<template>
  <div
      class="md:flex md:space-x-5 overflow-hidden relative rtl:space-x-reverse"
  >
    <div
        class="flex-1 md:w-[calc(100%-320px)]"
        :class="width < 768 ? 'h-full' : ''"
    >
      <Card
          bodyClass="p-0 h-full relative"
          :className="width < 1024 ? 'h-full' : ''"
      >
        <div class="all-allEmails px-6 h-full flex flex-col pt-6 pb-4">
          <List v-if="!$route.query.user" :accounts="applicants"
                :_title="$t('menuItems.account orders applicants')"
                :_emptyListMessage="$t('message.no user has booked account orders yet')"/>
          <Transition :enter-active-class="locale === 'fa' ? 'singleEmail-fa-enter-active' : 'singleEmail-enter-active'"
                      :leave-active-class="locale === 'fa' ? 'singleEmail-fa-leave-active' : 'singleEmail-leave-active'"
                      name="singleEmail">
            <ApplicantDetails @update-list="getApplicants" v-if="$route.query.user"/>
          </Transition>
        </div>
      </Card>
    </div>
  </div>
</template>
<script setup>
import Card from "@/components/Card/index.vue";
import {ref, onMounted} from "vue";
import List from "@/views/manageApplicants/list.vue";
import ApplicantDetails from "@/views/manageApplicants/account/applicantDetails/index.vue";
import {useI18n} from "vue-i18n";
import {useOrdersStore} from "@/stores/orders.js";
import {useRoute} from "vue-router";

const route = useRoute()
const applicants = ref([])
const ordersStore = useOrdersStore();
const width = ref(0);
const handleResize = () => {
  width.value = window.innerWidth;
};
onMounted(() => {
  window.addEventListener("resize", handleResize);
  handleResize();
});

const {locale} = useI18n({useScope: 'global'})

async function getApplicants() {
  await ordersStore.action_getAccountHotOrderApplicants({id: route.params.orderID})
  if (ordersStore.getAccountOrderApplicants.length) {
    applicants.value = ordersStore.getAccountOrderApplicants
  }
}

getApplicants();
</script>
<style lang="scss">
.singleEmail-enter-active {
  animation: fade-in-right 0.5s cubic-bezier(0.39, 0.575, 0.565, 1) both;
}

.singleEmail-leave-active {
  animation: fade-in-right 0.5s cubic-bezier(0.39, 0.575, 0.565, 1) both reverse;
}

.singleEmail-fa-enter-active {
  animation: fade-in-left 0.5s cubic-bezier(0.39, 0.575, 0.565, 1) both;
}

.singleEmail-fa-leave-active {
  animation: fade-in-left 0.5s cubic-bezier(0.39, 0.575, 0.565, 1) both reverse;
}

@-webkit-keyframes fade-in-right {
  0% {
    -webkit-transform: translateX(50px);
    transform: translateX(50px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes fade-in-right {
  0% {
    -webkit-transform: translateX(50px);
    transform: translateX(50px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
    opacity: 1;
  }
}


@-webkit-keyframes fade-in-left {
  0% {
    -webkit-transform: translateX(-50px);
    transform: translateX(-50px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes fade-in-left {
  0% {
    -webkit-transform: translateX(-50px);
    transform: translateX(-50px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
    opacity: 1;
  }
}


@-webkit-keyframes slide-in-right {
  0% {
    -webkit-transform: translateX(1000px);
    transform: translateX(1000px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes slide-in-right {
  0% {
    -webkit-transform: translateX(1000px);
    transform: translateX(1000px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
    opacity: 1;
  }
}

.email_height {
  height: calc(var(--vh, 1vh) * 100 - 12.1rem);
}

@media (max-width: 768px) {
  .email_height {
    height: calc(var(--vh, 1vh) * 100 - 10.5rem);
  }
}
</style>
